import { TextField } from '@chronosphereio/chrono-ui';
import { produce } from 'immer';
import { useCallback } from 'react';
import { BarChartStepOption, BarChartThresholdOptions } from '@/core';
import {
  ThresholdsEditor,
  ThresholdsEditorProps,
} from '@/plugin-editor-components/components/ThresholdsEditor/NewThresholdsEditor';

export const BarChartThresholdsEditor = ({
  thresholds,
  onChange,
}: {
  thresholds?: BarChartThresholdOptions;
  onChange: (newThresholds: BarChartThresholdOptions) => void;
}) => {
  const props: ThresholdsEditorProps<BarChartStepOption, BarChartThresholdOptions> = {
    onChange,
    renderStepOptions: ({ step, onStepChange }) => {
      return <BarChartThresholdStepEditor step={step} onStepChange={onStepChange} />;
    },
    thresholds,
    hideDefault: true,
  };

  return <ThresholdsEditor {...props} />;
};

function BarChartThresholdStepEditor<T extends Omit<BarChartStepOption, 'value'>>({
  step,
  onStepChange,
}: {
  step: T;
  onStepChange: (newStep: T) => void;
}) {
  const handleLabelChange = useCallback(
    (newLabel: string) => {
      onStepChange(
        produce(step, (draft) => {
          return { ...draft, name: newLabel };
        })
      );
    },
    [step, onStepChange]
  );

  return (
    <TextField
      inputProps={{ 'aria-label': 'enter threshold step label' }}
      defaultValue={step.name ?? ''}
      label="Label"
      fullWidth
      onBlur={(event) => handleLabelChange(event.currentTarget.value)}
    />
  );
}
